import { StateCreator } from "zustand";

import { TableSelectionState } from "../types";

const makeTableSelectionSlice =
  <T extends TableSelectionState>(): StateCreator<
    T,
    [["zustand/immer", never]],
    [["zustand/devtools", never]],
    TableSelectionState
  > =>
  (set) => ({
    selected: new Set(),
    disabledIds: new Set(),
    allItemsCount: 0,
    loading: false,

    addSelected: (ids: string[]) =>
      set((state) => {
        ids.forEach((id) => {
          if (!state.disabledIds.has(id)) {
            state.selected.add(id);
          }
        });
      }),
    replaceSelected: (ids: string[]) =>
      set((state) => {
        state.selected = new Set(ids);
        state.refetchSelected = undefined;
      }),
    toggle: (id: string) =>
      set((state) => {
        if (state.disabledIds.has(id)) return;

        if (state.selected.has(id)) {
          state.selected.delete(id);
        } else {
          state.selected.add(id);
        }
      }),
    setDisabledIds: (ids: string[]) =>
      set((state) => {
        state.disabledIds = new Set();
        ids.forEach((id) => {
          state.disabledIds.add(id);
          state.selected.delete(id);
        });
      }),
    setAllItemsCount: (count: number) =>
      set((state) => {
        state.allItemsCount = count;
      }),
    clearSelected: () =>
      set((state) => {
        state.selected.clear();
        state.refetchSelected = undefined;
      }),
    setLoading: (loading: boolean) =>
      set((state) => {
        state.loading = loading;
      }),

    refetchSelected: undefined,
    setRefetchSelected: (refetch: () => Promise<unknown>) =>
      set((state) => {
        state.refetchSelected = refetch;
      }),
  });

export default makeTableSelectionSlice;
